const translations = {
    en: {
        welcome: {
            summary: {
                reservation_number: "Reservation n°",
                check_in: "${date} from ${time}",
                check_out: "${date} until ${time}",
                not_checked_in: "Not checked-in yet",
                checked_in: "Check-In Completed",
                do_check_in_button: "CHECK-IN NOW"
            }
        }
    },
    de: {
        welcome: {
            summary: {
                reservation_number: "Reservierung n°",
                check_in: "${date} from ${time}",
                check_out: "${date} until ${time}",
                not_checked_in: "Noch nicht checked-in",
                checked_in: "Check-In abgeschlossen",
                do_check_in_button: "CHECK-IN JETZT"
            }
        }
    },
    es: {
        welcome: {
            summary: {
                reservation_number: "Numero de reserva",
                check_in: "${date} desde ${time}",
                check_out: "${date} hasta ${time}",
                not_checked_in: "no registrado todavia",
                checked_in: "registracion completada ",
                do_check_in_button: "registrense ahora"
            }
        }
    },
    fr: {
        welcome: {
            summary: {
                reservation_number: "Numéro de réservation",
                check_in: "${date} de ${time}",
                check_out: "${date} à ${time}",
                not_checked_in: "Ton temps est précieux",
                checked_in: "Enregistrement complété",
                do_check_in_button: "ENREGISTREZ-VOUS DÈS MAITENANT"
            }
        }
    },
    it: {
        welcome: {
            summary: {
                reservation_number: "Prenotazione n°",
                check_in: "${date} dalle ${time}",
                check_out: "${date} entro le ${time}",
                not_checked_in: "Entra in camera senza perdere un minuto",
                checked_in: "Check-In Completato",
                do_check_in_button: "FAI IL CHECK-IN ORA"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/welcome/Summary.js